export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer'
    },
    {
      name: 'Clients',
      url: '/clients',
      icon: 'icon-people'
    },
    {
      name: 'Reserves',
      url: '/reserves',
      icon: 'icon-book-open'
    },
    {
      name: 'SMS Logs',
      url: '/sms-logs',
      icon: 'fa fa-file-text-o'
    }
  ]
}
